module.exports = __webpack_public_path__ + "static/media/BannerOficialArco.2ea89895.png";